<template lang="pug">
  .detailsBox
    .controlBox
      .control
        img(src="https://file.s5yun.com/resources/appico/16155115160902636_jiejue.jpeg" alt="")
        .content
          h3 业务场景：<span>疫情防控</span>
          p 疫情防控主要用于学校、社区办公场景，进行人员登记、排查记录导出等，对公司的营业执照、组织机构代码证、税务登记证、资质证、劳动执法合格证证照管理社保登记证、个人职称证、岗位资格证等证件进行管理。证照过期、年审预警提醒，防止遗失并保证按时年检，特制订本功能，证照及资料由专人负责统一保管。
          a(href="javascript:;" @click="goMa") 立即体验
    .customer
      h4 客户档案及需求
      p 平凉市疫情管理防控，伴随着集团快速发展，核心业务流程信息化支撑较弱、各子公司（部门）间横向协同效率不高、信息上传下达主要靠QQ、系统应用体验不太好、系统未集成导致流程审批未打通等问题日渐突显，为了适应企业不断发展、满足高质量经营管理要求，疫情防控携手钉钉启动了新一代协同办公管理平台建设。疫情防控， 伴随着集团快速发展，核心业务流程信息化支撑较弱、各子公司（部门）间横向协同效率不高、信息上传下达主要靠QQ、系统应用体验不太好、系统未集成导致流程审批未打通等问题日渐突显，为了适应企业不断发展、满足高质量经营管理要求，疫情防控携手钉钉启动了新一代协同办公管理平台建设。
      a(href="javascript:;"  @click="goMa") 立即体验
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    goMa () {
      window.scroll(0, 0)
      var routeUrl = this.$router.resolve({
        path: '/ma',
        query: {}
      })
      window.open(routeUrl.href, '_blank')
    }
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .detailsBox{
    width: 100%;
    height: 1094px;
    border-top: 1px solid #E6E6E6;
    padding: 0px 0 106px;
    .controlBox{
      height: 518px;
      background-color: #f7f7f7;
      overflow: hidden;
      .control{
        width: 70%;
        height: 382px;
        margin: 62px auto 74px;
        img{
          width: 47%;
          height: 382px;
          float: left;
        }
        .content{
          width: 46%;
          float: left;
          margin-left: 31px;
          h3{
            font-size: 24px;
            font-weight: 400;
            margin: 20px 0;
            color: #353535;
            span{
              color: #007BF9;
            }
          }
          p{
            height: 240px;
            color: #666666;
            line-height: 30px;
            text-align:justify;
          }
          a{
            display: block;
            width: 120px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            background-color: #007bf9;
            color: #fff;
          }
        }
      }
    }
    .customer{
      width: 70%;
      height: 518px;
      margin: 59px auto 0;
      overflow: hidden;
      box-shadow: 0px 0px 7px rgba(0, 123, 249, 0.1);
      h4{
        font-size: 24px;
        font-weight: 400;
        text-align: center;
        margin: 57px 0 43px;
      }
      p{
        height: 248px;
        margin: 0 100px;
        text-align:justify;
        line-height: 30px;
      }
      a{
        display: block;
        width: 120px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        background-color: #007bf9;
        color: #fff;
        margin: 0 auto;
      }
    }
  }
</style>
